<template>
  <div class="company_tariff_devices" v-if="loading">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
        v-if="$store.getters.getPermissions.permissionGod === true"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'" v-if="$store.getters.getPermissions.permissionGod === true">
      <div class="form_select">
        <div class="select">
          <tree-select
              :options="tariff_list"
              :multiple="true"
              v-model="filter.tariff_ids"
              :placeholder="translate('tariffication.tariff_name')"
              :clearable="true"
              :limit="3"
              @input="change_input"
          />
        </div>

        <div class="select">
          <fg-input
              type="text"
              v-model="filter.service"
              :placeholder="translate('tariffication.order')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select">
        <div class="select">
          <tree-select
              :options="client_list"
              :multiple="true"
              v-model="filter.client_ids"
              :limit="3"
              :placeholder="translate('tariffication.client_name')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="select">
          <fg-input
              type="text"
              v-model="filter.fid"
              :placeholder="translate('tariffication.device_fid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select">
        <div class="select">
          <tree-select
              :options="option_list"
              :multiple="true"
              v-model="options"
              :placeholder="translate('tariffication.options')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="select">
          <tree-select
              :options="tariff_services_list"
              :multiple="true"
              v-model="filter.tariff_services"
              :placeholder="translate('tariffication.params_tariff')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select">
        <div class="select">
          <WrapDatePicker
              type="date"
              :placeholder="translate('tariffication.period')"
              v-model="filter.date"
              :range="true"
              :confirm="true"
              :clearable="true"
              :disabled_date="['2023-01-01', 'now']"
              value_type="format"
              format="DD-MM-YYYY"
              @input="change_input"
          />
        </div>

      </div>

      <div class="button">
        <span
          class="btn btn-warning btn-fill text-center"
          @click.prevent="clear_filter()"
        >
          {{ translate('filter.reset') }}
        </span>

        <span
          v-if="permission_commerce_god"
          class="btn btn-success btn-fill text-center"
          @click.prevent="new_device_tariff()"
        >
          {{ translate('tariffication.add_device_tariff') }}
        </span>
      </div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="Object.keys(summary).length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("tariffication.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer w50"
                @click="change_filter('id')"
                :class="{ selected: filter_type === 'id' }"
                v-if="$store.getters.getPermissions.permissionGod === true"
                scope="col"
            >
              {{ translate('tariffication.tariff_id') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer w50"
                @click="change_filter('status')"
                :class="{ selected: filter_type === 'status' }"
                scope="col"
            >
              {{ translate('tariffication.status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer w5per"
                @click="change_filter('device_uptime_status')"
                :class="{ selected: filter_type === 'device_uptime_status' }"
                scope="col"
            >
              {{ translate('tariffication.device_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer w5per"
                @click="change_filter('auto_block')"
                :class="{ selected: filter_type === 'auto_block' }"
                v-if="$store.getters.getPermissions.permissionGod === true"
                scope="col"
            >
              {{ translate('tariffication.auto_block_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('device_name')"
                :class="{ selected: filter_type === 'device_name' }"
                scope="col"
            >
              {{ translate('tariffication.device') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('order')"
                :class="{ selected: filter_type === 'order' }"
                scope="col"
            >
              {{ translate('tariffication.order') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('client_service_id')"
                :class="{ selected: filter_type === 'client_service_id' }"
                scope="col"
            >
              {{ translate('tariffication.service') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('client_id')"
                :class="{ selected: filter_type === 'client_id' }"
                v-if="$store.getters.getPermissions.permissionGod === true"
                scope="col"
            >
              {{ translate('tariffication.client_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('tariff_id')"
                :class="{ selected: filter_type === 'tariff_id' }"
                scope="col"
            >
              {{ translate('tariffication.tariff_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('username_start')"
                :class="{ selected: filter_type === 'username_start' }"
                v-if="$store.getters.getPermissions.permissionGod === true"
                scope="col"
            >
              {{ translate('tariffication.username') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer w7per"
                @click="change_filter('date_start')"
                :class="{ selected: filter_type === 'date_start' }"
                scope="col"
            >
              {{ translate('tariffication.date_start') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer w7per"
                @click="change_filter('date_end')"
                :class="{ selected: filter_type === 'date_end' }"
                scope="col"
            >
              {{ translate('tariffication.date_end') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
        <template v-for="tariff_device in tariff_device_list">
          <router-link
              v-if="$store.getters.getPermissions.permissionGod === true"
              :to="'/tariffed_device/' + tariff_device.id"
              class="tariff_item__link"
          >
            <TariffedDevicesItem
                :tariff_device="tariff_device"
            />
          </router-link>
          <template v-else>
            <TariffedDevicesItem
                :tariff_device="tariff_device"
            />
          </template>
        </template>


        </tbody>
      </table>
    </div>
  </div>

  <div class="loading" v-else>
    <div class="spinner">
      <scale-loader/>
    </div>
  </div>
</template>

<script>

import AddDeviceTariff from "./Modal/AddDeviceTariff.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import TariffedDevicesItem from "./Item/Index.vue"

export default {
  name: 'TariffedDevices',
  components: {
    WrapDatePicker,
    TariffedDevicesItem
  },
  props: ['tariffs'],

  data() {
    return {
      tariff_devices: [],
      loading: false,
      filter: {
        tariff_ids: [],
        client_ids: [],
        fid: "",
        tariff_services: [],
        date: [],
        tariffed: null,
        not_tariffed: null,
        awaiting_deactivation: null,
        service: "",
      },
      options: [],
      ts_date_options: {
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      },
      summary: {},
      open_link: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,

      filter_asc: "asc",
      filter_type: "",
    }
  },

  watch:{
    options:{
      deep: true,
      handler(){
        this.option_list.forEach((option) =>{
          if (this.options.indexOf(option.id) > -1){
            this.filter[option.id] = 1
          } else {
            this.filter[option.id] = null
          }
        })
      }
    },
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'tariffication_section' && this.$route.params.tariffication_section === "tariffed_devices") {
          let query = {}
          for (let key in this.filter) {
            switch (key) {
              case 'fid':
              case 'tariffed':
              case 'not_tariffed':
              case 'awaiting_deactivation':
              case 'service':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  query[key] = this.filter[key]
                }
                break;
              case 'date':
                if(this.filter[key][0] !== null && this.filter[key][1]){
                  query[key] = this.filter[key]
                }
                break;
              case 'client_ids':
              case 'tariff_ids':
              case 'tariff_services':
                if (this.filter[key].length > 0){
                  query[key] = this.filter[key]
                }
                break;
            }
          }
          let string = "?"
          Object.keys(query).forEach((item, key) => {
            if (key !== 0){
              string += `&${item}=${query[item]}`
            } else {
              string += `${item}=${query[item]}`
            }
          })
          if (this.$route.fullPath !== this.$route.path + string) this.$router.push(this.$route.path + string)
        }
      }
    },
  },

  computed: {
    permission_commerce_god(){
      return this.$store.getters.getPermissions.permissionCommerceGod === true
    },
    tariff_device_list(){
      let tariff_device_list = [...this.tariff_devices];
      return tariff_device_list.sort(this.compareNumbers);
    },
    option_list() {
      return [
        {id: "tariffed", label: this.translate("tariffication.billed")},
        {id: "not_tariffed", label: this.translate("tariffication.not_billed")},
        {id: "awaiting_deactivation", label: this.translate("tariffication.awaiting_deactivation")},
      ]
    },
    client_list() {
      return this.$store.getters.getClientsList.map((client) => {
        return {id: client.id, label: client.name}
      })
    },

    tariff_list() {
      return this.tariffs.map((tariff) => {
        if (tariff.id !== null) return {id: tariff.id, label: tariff.tariff_name}
      }).sort((a, b) => a.label > b.label ? 1 : -1)
    },
    tariff_services_list() {
      return this.$store.getters.getTariffServices.map((services) => {
        if (services.type !== null) return {id: services.type, label: services.title}
      }).sort((a, b) => a.id > b.id ? 1 : -1)
    },

    send_filter() {
      let filter = {}
      for (let key in this.filter) {
        switch (key){
          case 'fid':
          case 'service':
            if (this.filter[key] !== '' && this.filter[key] !== null && this.filter[key] !== undefined) {
              filter[key] = this.filter[key]
            }
            break;

          case 'tariffed':
          case 'not_tariffed':
          case 'awaiting_deactivation':
            this.filter[key] ? filter[key] = 1 : ''
            break;

          case 'date':
            if (this.filter[key][0] !== null && this.filter[key][0] !== undefined && this.filter[key][1] !== null && this.filter[key][1] !== undefined){
              filter.date_start = this.filter[key][0]
              filter.date_end = this.filter[key][1]
            }
            break;

          case 'client_ids':
          case 'tariff_ids':
          case 'tariff_services':
            if (this.filter[key].length > 0){
              filter[key] = this.filter[key]
            }
            break;
        }
      }
      return filter
    },
  },

  created() {
    this.check_query()
  },
  activated() {
    this.check_query()
  },
  deactivated() {
    this.filter = {
      tariff_ids: [],
      client_ids: [],
      fid: "",
      tariff_services: [],
      date: [],
      tariffed: null,
      not_tariffed: null,
      awaiting_deactivation: null,
      service: "",
    }
    this.options = []
  },

  methods: {
    check_query() {
      if (Object.keys(this.$route.query).length > 0) {
        for (let key in this.$route.query) {
          switch (key) {
            case 'fid':
            case 'service':
              this.filter[key] = this.$route.query[key]
              break;
            case 'tariff_services':
            case 'date':
              this.filter[key] = this.$route.query[key].split(',')
              break;

            case 'tariff_ids':
            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return Number(item)
              })
              break;

            case 'tariffed':
            case 'not_tariffed':
            case 'awaiting_deactivation':
              this.filter[key] = Number(this.$route.query[key])
              if(!this.options.indexOf(key) > -1){
                this.options.push(key)
              }
              break;
          }
        }
      }
      this.get_tariff_devices()
    },
    check_tariff() {
      if (this.$route.params.tariffication_item) {
        this.show_info(Number(this.$route.params.tariffication_item))
        this.check_link = true
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_tariff_devices, 500)
    },
    get_tariff_devices() {
      this.$http.v1.getCompanyTariffDevices(this.send_filter, (response) => {
        this.tariff_devices = response.data.data
        this.summary = response.data.summary
        this.loading = true
        this.check_tariff()
      })
    },
    clear_filter() {
      this.filter = {
        tariff_ids: [],
        client_ids: [],
        fid: "",
        tariff_services: [],
        date: [],
        tariffed: null,
        not_tariffed: null,
        awaiting_deactivation: null,
        service: ""
      }
      this.options = []
      this.change_input()
    },
    new_device_tariff() {
      let t = this.$createElement(AddDeviceTariff, {
        props: {
          prop_device_fid: this.filter.fid ? this.filter.fid : ''
        },
        on: {
          close: () => {
            this.$modal.hide('add_device_tariff')
          },
          confirm: () => {
            this.$modal.hide('add_device_tariff')
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'add_device_tariff'
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  },
}
</script>
<style lang='scss' scoped>
.company_tariff_devices {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex: 1;
    .form_select{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .select{
        margin-bottom: 10px;
        .vue-treeselect,
        .form-group{
          margin-bottom: 0;
        }
      }
      &.empty{
        @media (max-width: 1300px) {
          display: none;
        }
      }
    }

    .checkboxs {
      width: 50%;
      display: flex;
      align-content: center;
      justify-content: space-between;

      .checkbox {
        width: 50%;
        margin: 0;
        min-width: auto;
      }
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    & > * {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .response_table{
    flex: 10;
    padding: 0;
    @media (max-width: 767px) {
      margin: 0;
    }

    .tariff_item{
      &__link{
        color: #66615b;
      }
    }
  }
}


@media (max-width: 1300px) {
  .company_tariff_devices {
    .header {
      flex-wrap: wrap;

      & > * {
        margin: 5px;

        &:last-child {
          margin-right: 5px;
        }
      }

      .checkboxs {
        width: calc(50% - 10px);
      }
    }
  }
}

@media (max-width: 768px) {
  .company_tariff_devices {
    .header {
      flex-direction: column;

      .select {
        width: 100%;
      }

      .checkboxs {
        width: 100%;
      }
    }
  }
}


</style>
